import passwordValidator from 'password-validator';
import {
    fetchDataPromise,
    UnauthorizedError
} from './fetch'
import {
    logout,
    setAlertDanger,
    clearAlerts
} from '../store/WriteClass/reducer'

export const getAdminList = async (dispatch) => {
    try {
        let admins = await fetchDataPromise('/admin/list');
        return admins.json();  
    } catch(err) {
        if (err instanceof UnauthorizedError) {
            console.log('got an unauthorized error, logging out, redirecting to login page')
            dispatch(logout())
            dispatch(setAlertDanger({
                message: 'You do not have permission to view the admin area!',
                timeout: 3000,
                onDismiss: () => { dispatch(clearAlerts()) }
            }))
        } else {
            console.log("user request error:", err)
            dispatch(logout())
            return    
        }
    }
}

/**
 * Password policy:
 *  At least 8 characters
 *  At least 1 number
 *  At least 1 uppercase character
 * 
 * The function uses the same library as the API, so any changes here
 *   must be also made in the API.
 *
 * @param  {object} options.
 * The service.
 *
 * @return {bool|array}
 *  true if it passes, otherwise an array of reasons for password being invalid
 */
export const validatePassword = (password) => {
    var schema = new passwordValidator();
  
    schema
    .is().min(8)                                    // Minimum length 8
    .is().max(100)                                  // Maximum length 100
    .has().uppercase()                              // Must have uppercase letters
    .has().lowercase()                              // Must have lowercase letters
    .has().digits()                                 // Must have digits
    .is().not().oneOf(['Passw0rd', 'Password123']); // Blacklist these values
  
    const reasons = schema.validate(password, { list: true });
    return {
        valid: reasons.length === 0,
        reasons,
    };
  }



// WEBPACK FOOTER //
// ./src/utils/users.js